import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SignalRService } from '../../../../shared/signalR/signalR.service';

@Component({
  selector: 'app-signalr-test',
  templateUrl: './signalr-test.component.html',
  styleUrls: ['./signalr-test.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SignalRTestComponent implements OnInit {
  broadcastMessage = 'This is a test';
  disableTimeout = false;

  constructor(public signalRService: SignalRService,) { }

  ngOnInit() {
  }

  reconnectSignalR() {
    this.signalRService.disconnect();
    setTimeout(() => this.signalRService.connect(), 2000);
  }

  sendMessageToAllUsers() {
    this.signalRService.broadcastMessageToAll(this.broadcastMessage, this.disableTimeout);
  }

  sendMessageToDevelopers() {
    this.signalRService.broadcastMessageToDevelopers(this.broadcastMessage, this.disableTimeout);
  }
}



// WEBPACK FOOTER //
// ./src/app/developer/components/developer-tools/signalr-test/signalr-test.component.ts